<template>
  <div class="project-settings">
    <h3>项目设置</h3>
    
    <el-form :model="form" :rules="rules" ref="form" label-width="120px" style="max-width: 600px;">
      <el-form-item label="项目代号" prop="code">
        <el-input v-model="form.code" placeholder="请输入项目代号" disabled></el-input>
      </el-form-item>
      
      <el-form-item label="项目名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入项目名称"></el-input>
      </el-form-item>
      
      <el-form-item label="项目备注" prop="remark">
        <el-input 
          type="textarea" 
          v-model="form.remark" 
          placeholder="请输入项目备注"
          :rows="4"
        ></el-input>
      </el-form-item>
      
      <el-form-item label="项目状态" prop="status">
        <el-select v-model="form.status" style="width: 200px;">
          <el-option label="进行中" :value="1"></el-option>
          <el-option label="已完成" :value="2"></el-option>
        </el-select>
      </el-form-item>
      
      <el-divider content-position="left">项目时间范围</el-divider>
      
      <el-form-item label="开始时间">
        <el-date-picker
          v-model="form.startTime"
          type="date"
          placeholder="选择开始时间"
          value-format="yyyy-MM-dd"
          style="width: 200px;"
        ></el-date-picker>
      </el-form-item>
      
      <el-form-item label="截止时间">
        <el-date-picker
          v-model="form.endTime"
          type="date"
          placeholder="选择截止时间"
          value-format="yyyy-MM-dd"
          style="width: 200px;"
        ></el-date-picker>
      </el-form-item>
      
      
      <el-form-item>
        <el-button type="primary" @click="saveSettings" :loading="saving">保存设置</el-button>
      </el-form-item>
    </el-form>
    
    <el-divider></el-divider>
    
    <div class="danger-zone">
      <h4>危险操作</h4>
      <el-button type="danger" plain @click="deleteProject">删除项目</el-button>
      <p class="tip">删除项目后，项目下的所有问卷、波次数据将被移入回收站。</p>
    </div>
  </div>
</template>

<script>
import { getProjectDetail, updateProject, deleteProject } from 'index/api/project/manager'

export default {
  name: 'ProjectSettings',
  
  data() {
    return {
      loading: false,
      saving: false,
      form: {
        code: '',
        name: '',
        remark: '',
        status: 1,
        startTime: null,
        endTime: null,
        targetQuota: null
      },
      rules: {
        name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }]
      }
    }
  },
  
  computed: {
    projectId() {
      return this.$route.params.projectId
    }
  },
  
  mounted() {
    this.loadProject()
  },
  
  methods: {
    async loadProject() {
      this.loading = true
      try {
        const res = await getProjectDetail(this.projectId)
        console.log('[Settings] loadProject response:', res)
        
        // 兼容多种响应格式
        const data = res?.data?.data || res?.data || res
        console.log('[Settings] parsed data:', data)
        
        if (data) {
          this.form = {
            code: data.code || data.Code || '',
            name: data.name || data.Name || '',
            remark: data.remark || data.description || data.Description || '',
            status: data.status || data.Status || 1,
            startTime: data.startTime || data.StartTime || data.start_time || null,
            endTime: data.endTime || data.EndTime || data.end_time || null,
            targetQuota: data.targetQuota || data.TargetQuota || data.target_quota || null
          }
        }
      } catch (e) {
        console.error('加载项目详情失败', e)
        // 尝试从错误响应中获取数据
        const data = e?.data?.data || e?.data
        if (data) {
          this.form = {
            code: data.code || data.Code || '',
            name: data.name || data.Name || '',
            remark: data.remark || data.description || data.Description || '',
            status: data.status || data.Status || 1,
            startTime: data.startTime || data.StartTime || data.start_time || null,
            endTime: data.endTime || data.EndTime || data.end_time || null,
            targetQuota: data.targetQuota || data.TargetQuota || data.target_quota || null
          }
        }
      } finally {
        this.loading = false
      }
    },
    
    async saveSettings() {
      try {
        await this.$refs.form.validate()
        this.saving = true
        
        await updateProject({
          id: this.projectId,
          name: this.form.name,
          description: this.form.remark,
          status: this.form.status,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          targetQuota: this.form.targetQuota
        })
        
        this.$message.success('保存成功')
      } catch (e) {
        console.error('保存失败', e)
        if (e !== false) {
          const errMsg = e?.data?.message || e?.message || '保存失败'
          this.$message.error(errMsg)
        }
      } finally {
        this.saving = false
      }
    },
    
    deleteProject() {
      this.$confirm('确定删除该项目吗？删除后可在回收站恢复。', '警告', {
        type: 'warning',
        confirmButtonText: '确定删除',
        confirmButtonClass: 'el-button--danger'
      }).then(async () => {
        try {
          await deleteProject(this.projectId)
          this.$message.success('项目已删除')
          this.$router.push('/project')
        } catch (e) {
          const errMsg = e?.data?.message || e?.message || '删除失败'
          this.$message.error(errMsg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.project-settings {
  padding: 0;
  
  h3 {
    margin: 0 0 24px;
    font-size: 18px;
    font-weight: 500;
  }
}

.danger-zone {
  h4 {
    margin: 0 0 16px;
    font-size: 16px;
    color: #f56c6c;
  }
  
  .tip {
    margin-top: 12px;
    font-size: 13px;
    color: #909399;
  }
}

.form-tip {
  margin-left: 12px;
  font-size: 12px;
  color: #909399;
}
</style>
